/* eslint-disable react-hooks/exhaustive-deps */

import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useMemoTranslation = () => {
  const { t: _t, i18n } = useTranslation()
  const t = useMemo(() => _t, [i18n.language])
  return { t, i18n }
}
